import React from 'react';

import _ from 'lodash';

import Option from './Option';

class Menu extends React.Component {
    renderNoResultsMenu() {
        const {
            handleMouseDownOnMenu,
            searchTerm,
            items,
            isSuccess,
            noSearchTermRenderer,
            noResultsRenderer,
            warningRenderer,
            renderProps
        } = this.props;

        let container = <div className="no-results">No results found</div>;
        if (noResultsRenderer) {
            container = noResultsRenderer(searchTerm, renderProps);
        }

        if (noSearchTermRenderer) {
            const noSearchTerm =
                !searchTerm ||
                (_.isObject(searchTerm) && _.every(searchTerm, _.isEmpty));
            container =
                noSearchTerm || (!items.length && _.isNil(isSuccess))
                    ? noSearchTermRenderer(renderProps)
                    : container;
        }

        if (warningRenderer) {
            container = isSuccess === false ? warningRenderer() : container;
        }

        return (
            <div
                className="iwoca-select-container-wrapper"
                onMouseDown={handleMouseDownOnMenu}>
                <div className="iwoca-select-container">{container}</div>
            </div>
        );
    }
    renderMenuOptions() {
        const { items, optionRenderer, selectItem } = this.props;
        return items.map((item, index) => {
            return (
                <Option
                    onClick={() => selectItem(item)}
                    optionRenderer={optionRenderer}
                    key={index}
                    item={item}
                />
            );
        });
    }

    renderMenu() {
        const {
            handleMouseDownOnMenu,
            renderTopElement,
            renderBottomElement,
            renderProps
        } = this.props;

        return (
            <div
                className="iwoca-select-container-wrapper"
                onMouseDown={handleMouseDownOnMenu}>
                {renderTopElement ? renderTopElement(renderProps) : null}

                <div className="iwoca-select-container">
                    {this.renderMenuOptions()}
                </div>

                {renderBottomElement ? renderBottomElement(renderProps) : null}
            </div>
        );
    }

    render() {
        return this.props.items.length
            ? this.renderMenu()
            : this.renderNoResultsMenu();
    }
}

export default Menu;
